import { MBIconV2Name } from '@shared/components/image';
import { API } from '@shared/types/api';
import { isRelatedCardLookupComponent } from '../../utils';
import { FieldOption } from './FieldOption';

export class RelatedCardLookupFieldOption implements FieldOption {
  constructor(
    readonly title: string,
    readonly icon: MBIconV2Name,
    readonly component: Partial<API.RelatedCardLookupComponent>,
  ) {}

  matchesComponent(component: API.AnyComponent, _reservedIds: Array<string>): boolean {
    return isRelatedCardLookupComponent(component);
  }

  canBeAdded(_components: API.AnyComponent[]): boolean {
    return true;
  }
}
